
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.761 11.18H7.591l4.88-4.88a1 1 0 10-1.41-1.42l-6.59 6.59a1 1 0 000 1.41l6.58 6.6a1 1 0 101.41-1.41l-4.87-4.89h11.17a1 1 0 000-2z"}})])
          )
        }
      }
    